import {Typography} from '@mui/material';
import {env} from '../../config/env';

export default function NavBarLogoTitle() {
  return (
    <Typography
      data-testid="navbar-logo-title"
      variant="h6"
      sx={{
        fontWeight: 700,
        color: 'primary.main',
        fontSize: {xs: '1.25rem', md: '1.5rem'},
      }}
    >
      {env.appName}
    </Typography>
  );
}
